import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import {PAGE_STATE_RESET, PageStateResetAction, TOGGEL_AKTION_ACTION, ToggleAktionAction} from './aktionen.actions.ui';
import {AktionUi} from './aktionen.model.ui';
import {getVeranstaltungDeckblatt} from '../../app-state/app-state.reducer';
import {Aktion, VeranstaltungDetail} from '../../../../clients/veranstaltungen';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    activeAktionen: Array<string>;
}

export const initialPageState: PageState = {
    activeAktionen: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState);
        }

        case TOGGEL_AKTION_ACTION: {
            const a = <ToggleAktionAction>action;

            let res = [...state.activeAktionen];
            if (res.includes(a.aktionId)) {
                res = res.filter((x) => x !== a.aktionId);
            } else {
                res.push(a.aktionId);
            }

            return Object.assign({}, state, {activeAktionen: res});
        }

        default: {
            return state;
        }
    }
}


export const getModuleState = createFeatureSelector<ModuleState>('AktionenPage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getAktionen = createSelector(getPageState, getVeranstaltungDeckblatt, (state: PageState, veranstaltungDetail: VeranstaltungDetail) => {
    if (veranstaltungDetail == null) {
        return null;
    }
    return veranstaltungDetail.aktionen.map((aktion: Aktion) => <AktionUi>Object.assign({}, aktion, {open: state.activeAktionen.includes(aktion.aktion_id)}));
});



